import styles from '@/styles/category/new-arrivals.module.scss'
import { useState, useEffect } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import categoryApi from '@/service/modules/categoryApi'
import searchApi from '@/service/modules/searchApi'

interface Props {
  type?: string;
  title: string;
  category: number | string;
}

export default function CategoryLatestReviews({ type, title, category }: Props) {
  interface ProductItem {
    productID: string;
    name: string;
    url: string;
    imgUrl: string;
    price: number;
    normalPrice: number;
  }
  const [productData, setProductData] = useState<ProductItem[]>([]);

  const getNewArrivalsData = async () => {
    try {

      let param = 
        type == 'hotProducts' ? 
          searchApi.getHotProducts(category) 
          : categoryApi.getNewArrivals(category)
      let res = await param
      
      if (res.data && res.data.length) {
        res.data.forEach((item: any) => {
          item.imgUrl = item.newThumbnail || item.filename
        })
        setProductData(res.data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  // 页面onload再请求数据
  useEffect(() => {
    getNewArrivalsData()
  }, [category])

  return (
    <>
      {
        !!(productData && productData.length) &&
        <div className={styles['comp-new-arrivals']}>
          <div className={styles['title']}>
            {title}
          </div>

          <div className={styles['arrival-list']}>
            {
              productData.map((item: ProductItem, index: number) => (
                <Link
                  href={item.url}
                  key={item.url}
                  legacyBehavior
                >
                  <a rel="noopener noreferrer">
                    <div 
                      className={styles['product-item']} 
                      style={index + 1 == productData.length ? { border: 'none' } : undefined}
                    >
                      <Image
                        className={styles['product-image']}
                        alt={item.name}
                        width={65}
                        height={65}
                        src={item.imgUrl}
                      />

                      <div className={styles['product-info']}>
                        <div className={styles['product-name']}>{item.name}</div>
                        <div className={styles['product-price']}>${item.price}</div>
                      </div>
                    </div>
                  </a>
                </Link>
              ))
            }
          </div>
        </div>
      }
    </>
  )
}